import React, { useState } from "react";
import { getCsrfToken } from "./csrf";

const ActionLink = ({ action, nextPath, className, children }) => {
  const [sending, setSending] = useState(false);

  const handleClick = async () => {
    setSending(true);

    await fetch(action, {
      method: "POST",
      credentials: "same-origin",
      redirect: "manual",
      headers: { "X-CSRF-Token": getCsrfToken() }
    });

    window.location.href = nextPath;
  };

  return (
    <button
      type="button"
      className={`action-link ${className}`}
      disabled={sending}
      onClick={handleClick}
    >
      {children}
    </button>
  );
};

export default ActionLink;
